<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweennowrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input
            class="width100"
            v-model="input"
            placeholder="  请输入关键词查询"
          />
        </el-form-item>
        <div class="margin-left20">
          <el-button type="primary" class="searchbut" @click="submitForm()"
            >检 索</el-button
          >
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
      <div class="margin-top10 margin-bot10 pad-right20">
        <el-button
          @click="newlybuild"
          v-if="totops"
          class="margin-right10"
          style="padding: 5px 20px"
        >
          <img
            style="position: relative; top: 2px"
            src="@/assets/barsvg/xx／icon／14tj(1).png"
            alt=""
          />
          新建文件夹
        </el-button>
        <span
          class="attention"
          style="padding: 5px 20px"
          @click="dialogVisibletopfile = true"
          v-if="totops"
        >
          <img
            style="position: relative; top: 1px"
            src="@/assets/barsvg/xx／icon／14tj.png"
            alt=""
          />
          点击上传</span
        >
      </div>
    </div>
    <!-- 文件目录 -->
    <div class="width100 margin-auto backwhite margin-top15 border-rd3">
      <div
        class="
          all-title
          f14
          width98
          margin-auto
          flex-between
          pad-bot20 pad-top20
        "
      >
        <p class="cursorpointer width85 f12 pad-left10">
          <span class="bluecolor" @click="totop" v-if="totops">
            <img
              style="position: relative; top: 2px"
              src="@/assets/barsvg/xx／icon／12fh.png"
              alt=""
            />
            返回上级 |
          </span>
          <span @click="toheaddoc()">
            <span>根目录</span>
          </span>
          <span v-for="(item, index) in patharr" :key="index" class="bluecolor">
            <i
              slot="prefix"
              class="iconfont iconfonts icon-jiantou_liebiaoxiangyou jiantouyou"
            ></i>
            <span
              @click="todoc(index)"
              @dragover="allowDrops($event)"
              @drop="mydrops(index, $event)"
              >{{ item.name }}</span
            >
          </span>
        </p>
        <p class="width15 flex-between">
          <span style="position: relative; left: 15px">
            <span v-if="docdetails">文件详情</span>
          </span>
          <span
            @click="Putaway()"
            v-if="docdetails"
            class="pad-right10 cursorpointer"
          >
            <img src="@/assets/barsvg/xx／icon／12zk.png" alt="" />
            收起</span
          >
          <span
            @click="expansions()"
            v-if="expansion"
            class="pad-right10 cursorpointer"
          >
            <img src="@/assets/barsvg/xx／icon／12sq.png" alt="" />
            展开</span
          >
        </p>
      </div>
      <!-- 列表标题 -->
      <div
        class="width98 margin-auto flex-between"
        v-if="page.length != 0 || pages.length != 0"
      >
        <div
          class="flex-between pad-bot10 pad-top10 doctitle width85 headfile"
          ref="doctitle"
        >
          <div class="width40 flex pad-left10">
            <div
              class="buileder margin-top2"
              @click="allbuileder()"
              :class="
                buileder.length != 0 || buileders.length != 0 ? 'actives' : ''
              "
            >
              <img
                v-if="
                  buileder.length == page.length &&
                  buileders.length == pages.length
                "
                src="@/assets/barsvg/xx／xz／dx／wx.png"
                alt=""
              />
              <img
                v-if="
                  (buileder.length != 0 || buileders.length != 0) &&
                  buileder.length + buileders.length !=
                    page.length + pages.length
                "
                src="@/assets/barsvg/xx／xx／dx／wx_1.png"
                alt=""
              />
            </div>
            <span class="pad-left10">
              <span v-if="buileder.length == 0 && buileders.length == 0"
                >文件名</span
              >
              <span v-if="buileder.length != 0 || buileders.length != 0"
                >已选中{{ buileder.length + buileders.length }}个文件/文件夹
              </span></span
            >
          </div>
          <div class="width20 textalign-center">修改时间</div>
          <div class="width20 textalign-center">
            <span class="pad-left30">原创认证</span>
          </div>
          <div class="width20 textalign-center">
            <span class="pad-left20">大小</span>
          </div>
        </div>
        <div class="width15 docdetails" v-if="docdetails">
          <p class="width96 margin-auto flex-between pad-top10 f14"></p>
        </div>
      </div>
      <div
        class="width98 margin-auto flex-between"
        v-if="page.length == 0 && pages.length == 0"
      >
        <div
          class="flex-between pad-bot10 pad-top10 doctitle width85"
          ref="doctitle"
        ></div>
        <div class="width15 docdetails" v-if="docdetails"></div>
      </div>
      <!-- 列表 -->
      <div class="flex-between elradiogroup width98 margin-auto">
        <div
          class="Retrieveform width85 f14"
          ref="doccont"
          :style="{ height: screenHeight + 'px' }"
          @scroll="scrollEvent"
        >
          <!-- 文件夹列表 -->
          <div
            class="borderB width96 margin-left10 f12"
            v-if="page.length != 0 || pages.length != 0"
          ></div>
          <div v-if="page.length != 0 || pages.length != 0">
            <el-skeleton :loading="page.length != 0" :throttle="100">
              <template slot="template"
                ><div
                  v-for="(item, index) in page"
                  :key="index"
                  :label="item.id"
                  ref="myfileDiv"
                  class="
                    flex-betweencen
                    borderB
                    width100
                    f12
                    backmouse
                    lineheight40
                    pad-left10
                  "
                  style="position: relative"
                  @dragover="allowDrop($event)"
                  @drop="mydrop(index, $event)"
                  :class="buileder.indexOf(index) != -1 ? 'backhover' : ''"
                  @mouseenter="filemouseenter(index)"
                  @mouseleave="filemouseleave(index)"
                >
                  <div
                    class="buileder cursorpointer"
                    @click="itemChange(item, index)"
                    :class="buileder.indexOf(index) != -1 ? 'active' : ''"
                  >
                    <i
                      style="font-size: 12px"
                      slot="prefix"
                      class="iconfont iconfonts icon-dagou"
                    ></i>
                  </div>

                  <div
                    class="width40 pad-left20 flex"
                    @click="itemChange(item, index)"
                    draggable="true"
                    @dragstart="mydragstart(index, $event)"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/icon／20wjj.svg"
                      alt=""
                    />
                    <p
                      @click="opendocment(index)"
                      class="cursorpointer namehover pad-left10"
                      :class="item.name.length > 30 ? 'nameover' : ''"
                    >
                      {{ item.name }}
                    </p>
                  </div>
                  <div
                    class="flex rightdialog cursorpointer"
                    v-if="filemouse == index ? true : false"
                  >
                    <p @click="Filemovement(index)">
                      <i
                        slot="prefix"
                        class="iconfont iconfonts icon-move margin-right10"
                      ></i>
                    </p>
                    <p @click="removefile(index)">
                      <i
                        slot="prefix"
                        class="iconfont iconfonts icon-shanchu margin-right10"
                      ></i>
                    </p>
                    <p @click="openright(index)">
                      <i
                        slot="prefix"
                        class="iconfont iconfonts icon-bianji3 margin-right5"
                      ></i>
                    </p>
                  </div>
                  <div
                    class="width20 textalign-center"
                    @click="itemChange(item, index)"
                  >
                    <span>{{ item.create_time }}</span>
                  </div>
                  <div
                    @click="itemChange(item, index)"
                    class="width20 textalign-center"
                  >
                    --
                  </div>
                  <div
                    @click="itemChange(item, index)"
                    class="width20 textalign-center"
                  >
                    --
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
          <!-- 文件夹为空 -->
          <div
            v-if="page.length == 0 && pages.length == 0"
            class="margin-top50"
          >
            <el-skeleton
              :loading="page.length == 0 && pages.length == 0"
              :throttle="100"
            >
              <template slot="template">
                <div class="pad-bot10 width100 f12 pad-top10">
                  <el-empty
                    :image="require('@/assets/barsvg/icon／qsy／kwjj.png')"
                    style="position: relative; top: 60px"
                    :image-size="200"
                    description="当前文件夹为空，上传你的第一个文件吧~"
                    ><p style="position: relative; bottom: 60px" class="f14">
                      暂无文件
                    </p></el-empty
                  >
                </div>
              </template>
            </el-skeleton>
          </div>
          <!-- 文件列表 -->
          <div v-if="page.length != 0 || pages.length != 0">
            <el-skeleton :loading="pages.length != 0" :throttle="100">
              <template slot="template">
                <div
                  v-for="(item, index) in pages"
                  :key="index + 1000"
                  :label="item.id"
                  ref="myDiv"
                  class="
                    flex-betweencen
                    borderB
                    width85
                    f12
                    lineheight40
                    backmouse
                    pad-left10
                  "
                  style="position: relative"
                  :class="buileders.indexOf(index) != -1 ? 'backhover' : ''"
                  @mouseenter="filemouseenters(index)"
                  @mouseleave="filemouseleaves(index)"
                >
                  <div
                    class="buileder cursorpointer"
                    @click="itemChanges(item, index)"
                    :class="buileders.indexOf(index) != -1 ? 'actives' : ''"
                  >
                    <i
                      style="font-size: 12px"
                      slot="prefix"
                      class="iconfont iconfonts icon-dagou"
                    ></i>
                  </div>
                  <div
                    class="width40 pad-left20 flex"
                    @click="itemChanges(item, index)"
                    draggable="true"
                    @dragstart="mydragstarts(index, $event)"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-jpg png jpeg.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'jpg' ||
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'png' ||
                        item.original_name.substring(
                          item.original_name.length - 4,
                          item.original_name.length
                        ) == 'jpeg'
                      "
                    />
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-rar zip.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'zip' ||
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'rar'
                      "
                    />
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-pdf.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'pdf'
                      "
                    />
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-gif.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'gif'
                      "
                    />
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-txt.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'txt'
                      "
                    />
                    <img
                      style="width: 20px; height: 20px"
                      class="margin-top10"
                      src="@/assets/barsvg/20wjhz-doc.svg"
                      alt=""
                      v-if="
                        item.original_name.substring(
                          item.original_name.length - 4,
                          item.original_name.length
                        ) == 'docx' ||
                        item.original_name.substring(
                          item.original_name.length - 3,
                          item.original_name.length
                        ) == 'doc'
                      "
                    />

                    <span class="pad-left10">
                      <p
                        class="cursorpointer namehover"
                        @click="opendocfile(index)"
                        :class="
                          item.original_name.length > 30 ? 'nameover' : ''
                        "
                      >
                        {{ item.original_name }}
                      </p>
                    </span>
                  </div>
                  <div
                    class="flex rightdialog cursorpointer"
                    v-if="filesmouse == index ? true : false"
                  >
                    <p @click="Sharefiles(index)">
                      <i
                        slot="prefix"
                        class="iconfont iconfonts icon-get margin-right10"
                      ></i>
                    </p>
                    <p @click="Filemovements(index)">
                      <i
                        slot="prefix"
                        class="iconfont iconfonts icon-move margin-right10"
                      ></i>
                    </p>
                    <p
                      style="position: relative; top: 2px"
                      @click="muchoperation(index)"
                    >
                      <img
                        src="../../../assets/barsvg/xx／icon／14gd.png"
                        alt=""
                      />
                    </p>
                    <div class="muchoperation cursorpointer" v-if="operationtf">
                      <p class="operationitem" @click="opens()">重命名</p>
                      <p class="operationitem" @click="dialogVisibleimag()">
                        预 览
                      </p>
                      <p class="operationitem" @click="removesfile()">删 除</p>
                      <p class="operationitem" @click="downloadExcel()">
                        下 载
                      </p>
                    </div>
                  </div>
                  <div
                    class="width20 textalign-center"
                    @click="itemChanges(item, index)"
                  >
                    {{ item.create_time }}
                  </div>
                  <div
                    @click="itemChanges(item, index)"
                    class="width20 textalign-center"
                    v-if="item.identification === null"
                    @mouseover="mouseOver"
                    @mouseleave="mouseLeave"
                  >
                    <i
                      slot="prefix"
                      class="iconfont iconfonts icon-yuandianxiao doc"
                    ></i>
                    <span v-if="renzhen">未认证</span>
                  </div>
                  <div
                    class="width20 textalign-center"
                    @click="itemChanges(item, index)"
                    @mouseover="mouseOvers"
                    @mouseleave="mouseLeaves"
                    v-else
                  >
                    <i
                      slot="prefix"
                      class="iconfont iconfonts icon-yuandianxiao docgreen"
                    ></i>
                    <span v-if="renzhens">已认证</span>
                  </div>
                  <div
                    @click="itemChanges(item, index)"
                    class="width20 textalign-center"
                  >
                    {{ item.size }}
                  </div>
                </div></template
              >
            </el-skeleton>
          </div>
        </div>
        <!-- 右边详情 -->
        <div class="width15 docdetails" v-if="docdetails">
          <!-- 文件夹详情 -->
          <div
            class="width90 lineheight25 f14 titlestyle bordert-tf"
            style="position: relative; left: 20px"
            v-if="fileallsn"
          >
            <div
              class="f12 titlecor filedetail"
              :style="{ height: screenHeight - 40 + 'px' }"
              v-if="filepage.length != 0 || filepages.length != 0"
            >
              <div
                class="width100 margin-top20"
                style="background: #f9f9fc; height: 120px"
              >
                <img
                  style="
                    width: 70px;
                    height: 70px;
                    position: relative;
                    top: 25px;
                    left: 38%;
                  "
                  src="@/assets/barsvg/icon／wjlx／70wjj.png"
                  alt=""
                />
              </div>
              <p class="margin-top20">
                <span class="cursorpointer titlestyle">
                  {{ filepageName }}</span
                >
              </p>

              <div
                class="pad-top10 flex"
                v-for="(_item, _index) in filepage"
                :key="_index + 10000"
                :label="_item.id"
              >
                <div
                  class="cursorpointer flex"
                  :class="_item.name ? 'detailover' : ''"
                >
                  <div
                    class="greyburder margin-right10"
                    style="position: relative; top: 12px"
                  ></div>
                  <div style="color: #969eac; font-weight: 400">
                    {{ _item.name }}
                  </div>
                </div>
              </div>
              <div
                class="pad-top10 flex"
                v-for="(_item, _index) in filepages"
                :key="_index + 1000000"
                :label="_item.id"
              >
                <div
                  class="cursorpointer flex"
                  :class="_item.original_name ? 'detailover' : ''"
                >
                  <div
                    class="greyburder margin-right10"
                    style="position: relative; top: 12px"
                  ></div>
                  <div style="color: #969eac; font-weight: 400">
                    {{ _item.original_name }}
                  </div>
                </div>
              </div>
              <p class="f12" v-if="contspan">更多文件请在文件夹内查看</p>
            </div>
            <div v-if="filepage.length == 0 && filepages.length == 0">
              <div
                class="width100 margin-top20"
                style="background: #f9f9fc; height: 120px"
              >
                <img
                  style="
                    width: 70px;
                    height: 70px;
                    position: relative;
                    top: 25px;
                    left: 38%;
                  "
                  src="@/assets/barsvg/icon／wjll／70kwjj.png"
                  alt=""
                />
              </div>
              <p class="margin-top20">
                <span class="cursorpointer titlestyle">
                  {{ filepageName }}</span
                >
              </p>
              <p
                style="
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #969eac;
                "
                class="margin-top10"
              >
                此文件夹为空
              </p>
            </div>
          </div>
          <!-- 文件详情 -->

          <div
            div
            class="width90 lineheight25 f14 titlestyle bordert-tf"
            style="position: relative; left: 20px"
            v-if="filesn"
          >
            <div
              class="width100 margin-top20"
              style="background: #f9f9fc; height: 120px"
            >
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'jpg' ||
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'png' ||
                  original_name.substring(
                    original_name.length - 4,
                    original_name.length
                  ) == 'jpeg'
                "
                src="@/assets/barsvg/icon／wjlx／70jpg png jpeg.png"
                alt=""
              />
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'zip' ||
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'rar'
                "
                src="@/assets/barsvg/icon／wjlx／70rar zip.png"
                alt=""
              />
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'pdf'
                "
                src="@/assets/barsvg/icon／wjlx／70pdf.png"
                alt=""
              />
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'gif'
                "
                src="@/assets/barsvg/icon／wjlx／70GIF.png"
                alt=""
              />
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'txt'
                "
                src="@/assets/barsvg/icon／wjlx／70txt.png"
                alt=""
              />
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 37%;
                "
                v-if="
                  original_name.substring(
                    original_name.length - 4,
                    original_name.length
                  ) == 'docx' ||
                  original_name.substring(
                    original_name.length - 3,
                    original_name.length
                  ) == 'doc'
                "
                src="@/assets/barsvg/icon／wjlx／70doc.png"
                alt=""
              />
            </div>

            <div class="f12 titlecor">
              <p class="f14 titlestyles pad-top20 margin-bot20">
                {{ original_name }}
              </p>
              <div style="color: #969eac; font-weight: 400">
                <p>创 建 时 间 : {{ create_time }}</p>
                <p>最 后 修 改 : {{ create_time }}</p>
                <p>MIME : {{ mime }}</p>
                <p>文 件 大 小 : {{ size }}</p>
                <p>所 在 目 录 : {{ docmentName }}</p>
              </div>
            </div>
            <div class="margin-top20 titlecor f12" style="font-weight: 400">
              <p class="titlestyles pad-top10 pad-bot10" v-if="noauth">
                原创认证信息
              </p>
              <div v-if="noauth">
                <p>认证时间:</p>
                <p>{{ identificationTime }}</p>
                <p>证书号:</p>
                <p class="bluecolor">{{ identificationId }}</p>
                <p>认证机构:</p>
                <p>{{ identificationOrg }}</p>
              </div>

              <p class="pad-top20" v-if="authentication">
                <img
                  style="position: relative; top: 2px"
                  src="../../../assets/barsvg/icon／14zy.png"
                  alt=""
                />
                该文件还没有进行原创认证
              </p>
              <div
                class="textalign-left f14 margin-top10"
                v-if="authentication"
              >
                <el-button @click="protect">立即认证</el-button>
              </div>
            </div>
          </div>
          <!-- 多个文件或者文件夹 -->
          <div
            div
            class="width90 lineheight25 f14 titlestyle bordert-tf"
            style="position: relative; left: 20px"
            v-if="muchfilesn"
          >
            <div
              class="width100 margin-top20"
              style="background: #f9f9fc; height: 120px"
            >
              <img
                style="
                  width: 70px;
                  height: 70px;
                  position: relative;
                  top: 25px;
                  left: 38%;
                "
                src="@/assets/barsvg/icon／wjlx／70wjj.png"
                alt=""
              />
            </div>

            <p
              style="
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969eac;
              "
              class="margin-top10"
            >
              共选择了{{ filenum }}个文件
            </p>
          </div>
          <!-- 空状态 -->
          <div
            div
            class="width90 lineheight25 f14 titlestyle"
            style="position: relative; left: 20px"
            v-if="filesn == false && fileallsn == false && muchfilesn == false"
          >
            <p
              style="
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969eac;
                margin-top: 50%;
              "
              class="textalign-center"
            >
              选中文件/文件夹，查看详情
            </p>
          </div>
        </div>
        <!-- 黑色功能框 -->
      </div>
      <div
        class="functionbox cursorpointer"
        v-if="buileder != '' || buileders != ''"
      >
        <el-tooltip class="item" effect="dark" content="分享" placement="top">
          <div
            class="functionitem"
            v-if="buileder == '' && buileders.length == 1"
            @click="Sharefilesb()"
          >
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14fx.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="下载" placement="top">
          <div
            class="functionitem"
            v-if="buileder == '' && buileders.length == 1"
            @click="downloadExcel()"
          >
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14xz.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <!-- 文件重命名 -->
        <el-tooltip
          class="item"
          effect="dark"
          content="文件夹重命名"
          placement="top"
        >
          <div
            class="functionitem"
            v-if="buileder != '' && buileders == '' && buileder.length == 1"
            @click="open"
          >
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14cmm.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <!-- 文件夹重命名 -->
        <el-tooltip
          class="item"
          effect="dark"
          content="文件重命名"
          placement="top"
        >
          <div
            class="functionitem"
            v-if="buileders != '' && buileder == '' && buileders.length == 1"
            @click="opensb"
          >
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14cmm.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="移动" placement="top">
          <div class="functionitem" @click="Filemovementall">
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14ydd.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="预览" placement="top">
          <div
            class="functionitem"
            v-if="buileder == '' && buileders.length == 1"
            @click="dialogVisibleimag"
          >
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14yl.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="删除" placement="top">
          <div class="functionitem" @click="removefileall">
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14sc.png"
              alt=""
            />
          </div>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="关闭" placement="top">
          <div class="functionitem" @click="outblackbox">
            <img
              class="functionboximg"
              src="@/assets/barsvg/xx／icon／14gb.png"
              alt=""
            />
          </div>
        </el-tooltip>
      </div>
    </div>
    <!-- 错误信息 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 文件上传 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibletopfile"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorbox"
    >
      <p class="textalign-left f16">文件上传</p>
      <el-upload
        ref="upload"
        class="upload-demo uploaddragger margin-top20"
        drag
        multiple
        :action="Apisrc"
        :on-progress="handleprogress"
        :before-upload="beforeUpload"
        :on-success="handlesuccess"
        :on-error="handleerror"
        :show-file-list="false"
        :data="user"
        :headers="head"
        :limit="limit"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          一次最多上传{{ limit }}个文件,单个文件不超过10M
        </div>
      </el-upload>
      <el-row type="flex" justify="center">
        <div style="width: 90%">
          <div
            class="fileTemp"
            v-for="(file, index) in uploadFiles"
            :key="index"
          >
            <div class="progress-bar" v-if="elprogress">
              <div
                class="progress"
                :class="elprogress == false ? '' : 'animate'"
              ></div>
            </div>
            <div class="flex-betweenNowrapAlign">
              <div class="overhide">
                <i class="el-icon-receiving" style="margin-right: 5px"></i>
                {{ file.name }}
              </div>

              <i
                class="el-icon-circle-close"
                @click="removetopfile(index)"
                style="margin-right: 5px"
              ></i>
            </div>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!-- 文件预览 -->
    <el-dialog title="预览" :visible.sync="dialogVisibleimage" width="35%">
      <el-image
        lazy
        style="width: 100%"
        :preview-src-list="[voucher]"
        :src="voucher"
      >
      </el-image>
    </el-dialog>
    <!-- 文件分享 -->
    <el-dialog
      title="文件分享"
      :visible.sync="dialogVisibleshare"
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
    >
      <el-input
        v-model="phonshare"
        placeholder="请输入接收人手机号码"
        class="inputshare"
        type="number"
      ></el-input>
      <el-date-picker
        class="margin-top10 inputshare"
        v-model="timeshare"
        type="date"
        placeholder="请选择分享结束时间"
        value-format="yyyy-MM-dd"
        :editable="false"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-input
        class="margin-top10 inputshare"
        type="textarea"
        :autosize="autosize"
        :rows="2"
        placeholder="请输入附言"
        v-model="sharetextarea"
      ></el-input>
      <span slot="footer" class="dialog-footer flex-between">
        <el-button @click="nullshare()">取 消</el-button>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 文件夹重命名 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblefilebox"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <button class="btnn">文件夹重命名</button>
      <el-input
        v-model="filebox"
        placeholder="请输入文件夹名字"
        class="addinput"
      ></el-input>
      <div class="botbox">
        <el-button @click="nullfilebox()">取 消</el-button>
        <el-button type="primary" @click="fileproject()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 文件重命名 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblefile"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <button class="btnn">文件重命名</button>
      <el-input
        v-model="fileinput"
        placeholder="请输入文件名字"
        class="addinput"
      ></el-input>
      <div class="botbox">
        <el-button @click="nullfile()">取 消</el-button>
        <el-button type="primary" @click="itemproject()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 文件或者文件夹移动 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemove"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
    >
      <p class="movebtnn f16">移动到</p>
      <p class="cursorpointer width85 f12 pad-top10">
        <span class="bluecolor" v-if="allfiletotops" @click="allfiletop"
          >返回上一级 |</span
        >
        <span v-if="!allfiletotops"> 当前路径 :</span>
        <span @click="toallfiledoc()">
          <span> 根目录</span>
        </span>
        <span
          v-for="(item, index) in allfilepatharr"
          :key="index"
          class="bluecolor"
        >
          <i
            slot="prefix"
            class="iconfont iconfonts icon-jiantou_liebiaoxiangyou jiantouyou"
          ></i>
          <span @click="allfileitem(index)">{{ item.name }}</span>
        </span>
      </p>
      <div>
        <div v-if="allfilepage.length != 0">
          <el-skeleton
            :loading="allfilepage.length != 0"
            :throttle="100"
            class="dialogmove"
          >
            <template slot="template">
              <div
                v-for="(item, index) in allfilepage"
                :key="index"
                :label="item.id"
                class="borderB width100 f12 lineheight40"
                @click="opendilogflie(index)"
              >
                <div class="pad-left10 flex">
                  <img
                    style="width: 20px; height: 20px"
                    class="margin-top10"
                    src="@/assets/barsvg/icon／20wjj.svg"
                    alt=""
                  />
                  <p
                    class="cursorpointer namehover pad-left10"
                    :class="item.name.length > 30 ? 'nameover' : ''"
                  >
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>

        <!-- 文件夹为空 -->
        <div v-if="allfilepage.length == 0">
          <el-skeleton :loading="allfilepage.length == 0" :throttle="100">
            <template slot="template">
              <div class="pad-bot10 width100 f12 pad-top10">
                <el-empty description="当前文件夹为空"></el-empty>
              </div>
            </template>
          </el-skeleton>
        </div>
      </div>
      <div class="textalign-right">
        <el-button @click="dialogVisiblemove = false">取 消</el-button>
        <el-button type="primary" @click="movefilesuer">移动到此</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  documentindex,
  documentmkdir,
  documentrename,
  documentdelete,
  documentfilerename,
  documentidentification,
  fileshareshare,
  documentmove,
} from "@/api/loader/loder.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      filemouse: -1,
      filesmouse: -1,
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleimage: false,
      dialogVisibleshare: false,
      dialogVisibdoc: false,
      dialogVisiblfile: false,
      dialogVisibletopfile: false,
      dialogVisiblemove: false,
      phonshare: "",
      timeshare: "",
      sharetextarea: "",
      user: {
        cate_id: "",
        filename: "",
      },
      doctourlid: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      page: [],
      pages: [],
      page1: [],
      thisNum: 1,
      radio: "",
      docfile: false,
      files: false,
      removefiles: false,
      totops: true,
      parent_id: "",
      filesn: false,
      fileallsn: false,
      muchfilesn: false,
      original_name: "",
      create_time: "",
      mime: "",
      size: "",
      identificationTime: "",
      identificationId: "",
      identificationOrg: "",
      docmentName: "",
      authentication: true,
      noauth: false,
      serchkey: true,
      input: "",
      voucher: "",
      readonly: true,
      readonlys: true,
      clicknum: 0,
      clicknums: 0,
      patharr: [],
      isaaa: "",
      isbbb: "",
      numm: -1,
      nummfile: -1,
      Apisrc: "",
      buileder: [],
      buileders: [],
      dialogVisiblefilebox: false,
      filebox: "",
      dialogVisiblefile: false,
      fileinput: "",
      renzhen: false,
      renzhens: false,
      limit: "",
      docdetails: true,
      expansion: false,
      contspan: false,
      filepageName: "",
      filepage: [],
      filepages: [],
      filenum: "",
      screenHeight: "",
      allfilepage: [],
      allfilepages: [],
      filepageparent_id: "",
      allfilepatharr: "",
      allfiletotops: true,
      allfilecontid: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      movepageid: "",
      movepagesid: "",
      Sharefilesid: "",
      operationindex: "",
      operationtf: false,
      uploadFiles: [],
      elprogress: false,
      limits: 20,
    };
  },
  components: {
    callback,
    switchcore,
  },
  watch: {
    // 监听文件夹选择个数
    buileder() {
      if (this.buileder.length + this.buileders.length >= 2) {
        this.filesn = false;
        this.fileallsn = false;
        this.muchfilesn = true;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else if (this.buileder.length != 0 && this.buileders.length == 0) {
        this.filesn = false;
        this.fileallsn = true;
        this.muchfilesn = false;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else if (this.buileders.length != 0 && this.buileder.length == 0) {
        this.filesn = true;
        this.fileallsn = false;
        this.muchfilesn = false;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else {
        this.filesn = false;
        this.fileallsn = false;
        this.muchfilesn = false;
        this.removefiles = false;
        this.docfile = false;
        this.files = false;
      }
      if (this.buileder.length == 1 && this.buileders.length == 0) {
        this.docfile = true;
        this.files = false;
      } else if (this.buileder.length == 0 && this.buileders.length == 1) {
        this.files = true;
        this.docfile = false;
      }
      this.filenum = this.buileder.length + this.buileders.length;
    },
    // 监听文件选择个数
    buileders() {
      if (this.buileder.length + this.buileders.length >= 2) {
        this.filesn = false;
        this.fileallsn = false;
        this.muchfilesn = true;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else if (this.buileder.length != 0 && this.buileders.length == 0) {
        this.filesn = false;
        this.fileallsn = true;
        this.muchfilesn = false;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else if (this.buileders.length != 0 && this.buileder.length == 0) {
        this.filesn = true;
        this.fileallsn = false;
        this.muchfilesn = false;
        this.removefiles = true;
        this.docfile = false;
        this.files = false;
      } else {
        this.filesn = false;
        this.fileallsn = false;
        this.muchfilesn = false;
        this.removefiles = false;
        this.docfile = false;
        this.files = false;
      }
      if (this.buileder.length == 1 && this.buileders.length == 0) {
        this.docfile = true;
        this.files = false;
      } else if (this.buileder.length == 0 && this.buileders.length == 1) {
        this.files = true;
        this.docfile = false;
      }
      this.filenum = this.buileder.length + this.buileders.length;
    },
    // 监听屏幕可视高度
    screenHeight() {
      if (document.body.clientHeight < 900) {
        this.screenHeight = document.body.clientHeight - 260;
      } else if (900 < document.body.clientHeight < 1000) {
        this.screenHeight = document.body.clientHeight - 300;
      } else if (1000 < document.body.clientHeight < 1060) {
        this.screenHeight = document.body.clientHeight - 350;
      } else {
        this.screenHeight = document.body.clientHeight - 400;
      }
    },
  },
  methods: {
    // 阻止元素的这种默认的处理方式
    allowDrop($event) {
      $event.preventDefault();
    },
    allowDrops($event) {
      $event.preventDefault();
    },
    // 拖动的元素
    mydragstart(index, $event) {
      window.sessionStorage.setItem("dataTransfer", this.page[index].id);
    },
    // 拖动的元素
    mydragstarts(index, $event) {
      window.sessionStorage.setItem("dataTransfers", this.pages[index].id);
    },
    // 元素放置的地方--文件夹
    mydrop(index, $event) {
      var id = window.sessionStorage.getItem("dataTransfer");
      var ids = window.sessionStorage.getItem("dataTransfers");
      documentmove({
        target: this.page[index].id,
        dirs: [id],
        files: [ids],
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          window.sessionStorage.setItem("dataTransfer", "");
          window.sessionStorage.setItem("dataTransfers", "");
        } else {
          window.sessionStorage.setItem("dataTransfer", "");
          window.sessionStorage.setItem("dataTransfers", "");
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 元素放置的地方--文件路径
    mydrops(index, $event) {
      var id = window.sessionStorage.getItem("dataTransfer");
      var ids = window.sessionStorage.getItem("dataTransfers");
      documentmove({
        target: this.patharr[index].id,
        dirs: [id],
        files: [ids],
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          window.sessionStorage.setItem("dataTransfer", "");
          window.sessionStorage.setItem("dataTransfers", "");
        } else {
          window.sessionStorage.setItem("dataTransfer", "");
          window.sessionStorage.setItem("dataTransfers", "");
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 移入
    mouseOver() {
      this.renzhen = true;
    },
    // 移出
    mouseLeave() {
      this.renzhen = false;
    },
    // 移入
    mouseOvers() {
      this.renzhens = true;
    },
    // 移出
    mouseLeaves() {
      this.renzhens = false;
    },
    // 文件分享
    handleClose() {
      this.numm = -1;
      this.nummfile = -1;
      fileshareshare({
        id: this.Sharefilesid, //文件ID
        phone: this.phonshare, //目标用户名
        message: this.sharetextarea,
        expire_time: this.timeshare, //过期时间
      }).then((res) => {
        if (res.data.code == 200) {
          this.$confirm("查看分享?")
            .then((_) => {
              this.$router.push({
                path: "/Enterprise-networkdisk/Permission-Settings",
              });
            })
            .catch((_) => {
              this.dialogVisibleshare = false;
            });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件上传
    topfile() {
      this.nummfile = -1;
      this.numm = -1;
    },
    // 移入分享文件
    Sharefiles(index) {
      this.Sharefilesid = this.pages[index].id;
      this.dialogVisibleshare = true;
      this.numm = -1;
      this.nummfile = -1;
    },
    // 黑色悬浮框分享
    Sharefilesb() {
      this.Sharefilesid = this.pages[this.buileders[0]].id;
      this.dialogVisibleshare = true;
      this.numm = -1;
      this.nummfile = -1;
    },
    // 取消分享
    nullshare() {
      this.dialogVisibleshare = false;
      this.numm = -1;
      this.nummfile = -1;
    },
    // 认证
    protect() {
      this.numm = -1;
      this.nummfile = -1;
      documentidentification({
        file_id: parseInt(window.sessionStorage.getItem("filetoid")),
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "认证成功",
            type: "success",
          });
          this.authentication = false;
          this.noauth = true;
          this.identificationTime = res.data.data.create_time;
          this.identificationId = res.data.data.cert_id;
          this.identificationOrg = res.data.data.org;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 返回上一级
    totop() {
      window.sessionStorage.setItem("doctourlid", this.parent_id);
      this.user.cate_id = this.parent_id;
      this.numm = -1;
      this.nummfile = -1;
      this.filesn = false;
      this.fileallsn = false;
      this.muchfilesn = false;
      this.buileders = [];
      this.buileder = [];
      this.docfile = false;
      this.files = false;
      this.removefiles = false;
      documentindex({ parent_id: this.parent_id, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.self == null) {
            this.totops = false;
            this.docmentName = "根目录";
            //    this.parent_id = res.data.data.self.id;
            // this.selfname = res.data.data.self.name;
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
            this.parent_id = res.data.data.self.id;
            this.selfname = res.data.data.self.name;
          }
          this.page = res.data.data.dir;
          this.refresh();
          this.patharr = res.data.data.path;
          this.pages = res.data.data.file.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新建文件夹
    newlybuild() {
      this.numm = -1;
      this.nummfile = -1;
      this.$prompt("请输入文件夹名字", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          documentmkdir({
            parent_id: window.sessionStorage.getItem("doctourlid"),
            name: value,
          }).then((res) => {
            if (res.data.code == 200) {
              if (res.data.data.self == null) {
                window.sessionStorage.setItem("doctourlid", 0);
                this.user.cate_id = 0;
                this.totops = false;
              } else {
                window.sessionStorage.setItem(
                  "doctourlid",
                  res.data.data.self.id
                );
                this.user.cate_id = res.data.data.self.id;
                this.totops = true;
              }
              this.thisNum = 1;
              documentindex({
                parent_id: window.sessionStorage.getItem("doctourlid"),
                limit: this.limits,
                page: this.thisNum,
              }).then((res) => {
                if (res.data.code == 200) {
                  this.$loading.hide(); // 隐藏loading
                  if (res.data.data.self == null) {
                    this.totops = false;
                  } else {
                    this.totops = true;
                    this.docmentName = res.data.data.self.name;
                    this.selfname = res.data.data.self.name;
                    this.user.cate_id = res.data.data.self.id;
                  }
                  this.page = res.data.data.dir;
                  this.pages = res.data.data.file.data;
                  this.parent_id = res.data.data.parent.id;
                  this.patharr = res.data.data.path;
                } else {
                  this.$loading.hide(); // 隐藏loading
                  this.dialogVisiblenull = true;
                  this.errormessage = res.data.msg;
                }
              });
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 文件夹删除
    removefile(index) {
      let builederid = [];
      if (this.buileder.length == 0) {
        builederid.push(this.page[index].id);
      } else {
        this.buileder.forEach((item) => {
          builederid.push(this.page[item].id);
        });
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          documentdelete({ dirs: builederid, files: [] }).then((res) => {
            if (res.data.code == 200) {
              this.buileder = [];
              this.buileders = [];
              this.numm = -1;
              this.nummfile = -1;
              this.filesn = false;
              this.fileallsn = false;
              this.muchfilesn = false;
              this.files = false;
              this.removefiles = false;
              this.refresh();
            } else {
              this.numm = -1;
              this.nummfile = -1;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.numm = -1;
          this.nummfile = -1;
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 文件删除
    removesfile() {
      let builedersid = [];
      if (this.buileders.length == 0) {
        builedersid.push(this.pages[this.operationindex].id);
      } else {
        this.buileders.forEach((item) => {
          builedersid.push(this.pages[item].id);
        });
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          documentdelete({ dirs: [], files: builedersid }).then((res) => {
            if (res.data.code == 200) {
              this.buileder = [];
              this.buileders = [];
              this.numm = -1;
              this.nummfile = -1;
              this.filesn = false;
              this.fileallsn = false;
              this.muchfilesn = false;
              this.files = false;
              this.removefiles = false;
              this.refresh();
            } else {
              this.numm = -1;
              this.nummfile = -1;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.numm = -1;
          this.nummfile = -1;
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 文件文件夹一起删除
    removefileall() {
      let builederid = [];
      let builedersid = [];
      this.buileder.forEach((i) => {
        builederid.push(this.page[i].id);
      });
      this.buileders.forEach((i) => {
        builedersid.push(this.pages[i].id);
      });
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          documentdelete({ dirs: builederid, files: builedersid }).then(
            (res) => {
              if (res.data.code == 200) {
                this.buileder = [];
                this.buileders = [];
                this.numm = -1;
                this.nummfile = -1;
                this.filesn = false;
                this.fileallsn = false;
                this.muchfilesn = false;
                this.files = false;
                this.removefiles = false;
                this.refresh();
              } else {
                this.numm = -1;
                this.nummfile = -1;
                this.dialogVisiblenull = true;
                this.errormessage = res.data.msg;
              }
            }
          );
        })
        .catch(() => {
          this.numm = -1;
          this.nummfile = -1;
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 保存更多按钮index
    muchoperation(index) {
      this.operationtf = true;
      this.operationindex = index;
      this.voucher = this.pages[this.operationindex].url;
    },
    // 收起
    Putaway() {
      this.$refs.doccont.style.width = "100%";
      this.$refs.doctitle.style.width = "100%";
      this.docdetails = false;
      this.expansion = true;
      this.nummfile = -1;
      this.numm = -1;
    },
    // 展开
    expansions() {
      this.$refs.doccont.style.width = "85%";
      this.$refs.doctitle.style.width = "85%";
      this.docdetails = true;
      this.expansion = false;
      this.nummfile = -1;
      this.numm = -1;
    },
    // 打开文件夹
    opendocment(index) {
      window.sessionStorage.setItem("doctourlid", this.page[index].id);
      this.user.cate_id = this.page[index].id;
      this.numm = -1;
      this.nummfile = -1;
      this.filesn = false;
      this.fileallsn = false;
      this.muchfilesn = false;
      this.files = false;
      this.removefiles = false;
      documentindex({ parent_id: this.page[index].id, limit: 20 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.buileders = [];
            this.buileder = [];
            if (res.data.data.self == null) {
              this.totops = false;
              this.docmentName = "根目录";
            } else {
              this.totops = true;
              this.docmentName = res.data.data.self.name;
            }
            this.page = res.data.data.dir;
            this.refresh();
            this.pages = res.data.data.file.data;
            this.parent_id = res.data.data.self.id;
            this.selfname = res.data.data.self.name;
            this.docfile = false;
            this.files = false;
            this.removefiles = false;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 打开文件
    opendocfile(index) {
      this.numm = -1;
      this.nummfile = -1;
      window.sessionStorage.setItem("filetoid", this.pages[index].id);
      window.sessionStorage.setItem("filetoindex", index);
      this.filesn = true;
      this.fileallsn = false;
      this.muchfilesn = false;
      this.buileders = [];
      this.buileder = [];
      this.files = false;
      this.removefiles = false;
      // this.$refs.doccont.style.width = "100%";
      // this.$refs.alltitle.style.width = "100%";
      this.original_name = this.pages[index].original_name;
      this.create_time = this.pages[index].create_time;
      this.mime = this.pages[index].mime;
      this.size = this.pages[index].size;
      if (this.pages[index].identification == null) {
        this.identificationTime = "未认证";
        this.identificationId = "未认证";
        this.identificationOrg = "未认证";
        this.authentication = true;
        this.noauth = false;
      } else {
        this.identificationTime = this.pages[index].identification.create_time;
        this.identificationId = this.pages[index].identification.cert_id;
        this.identificationOrg = this.pages[index].identification.org;
        this.authentication = false;
        this.noauth = true;
      }
      this.voucher = this.pages[index].url;
      var url = window.g.Apisrc + this.voucher;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    // 文件夹改名
    open() {
      this.numm = -1;
      this.nummfile = -1;
      this.dialogVisiblefilebox = true;
      this.filebox =
        this.page[window.sessionStorage.getItem("doctourlindex")].name;
    },
    fileproject() {
      documentrename({
        id: this.page[window.sessionStorage.getItem("doctourlindex")].id,
        name: this.filebox,
      }).then((res) => {
        if (res.data.code == 200) {
          this.filepageName =
            res.data.data.dir[
              window.sessionStorage.getItem("doctourlindex")
            ].name;
          this.numm = -1;
          this.nummfile = -1;
          this.dialogVisiblefilebox = false;
          if (res.data.data.self == null) {
            window.sessionStorage.setItem("doctourlid", 0);
            this.user.cate_id = 0;
            this.totops = false;
          } else {
            window.sessionStorage.setItem("doctourlid", res.data.data.self.id);
            this.user.cate_id = res.data.data.self.id;
            this.totops = true;
          }
          this.refresh();
        } else {
          this.numm = -1;
          this.nummfile = -1;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消改名
    nullfilebox() {
      this.dialogVisiblefilebox = false;
      this.numm = -1;
      this.nummfile = -1;
    },
    // 文件改名
    opens() {
      this.numm = -1;
      this.nummfile = -1;
      this.dialogVisiblefile = true;
      this.fileinput = this.pages[this.operationindex].original_name;
      this.filenameid = this.pages[this.operationindex].id;
    },
    opensb() {
      this.numm = -1;
      this.nummfile = -1;
      this.dialogVisiblefile = true;
      this.fileinput = this.pages[this.buileders[0]].original_name;
      this.filenameid = this.pages[this.buileders[0]].id;
    },
    itemproject() {
      documentfilerename({
        id: this.filenameid,
        filename: this.fileinput,
      }).then((res) => {
        if (res.data.code == 200) {
          this.filesn = false;
          this.fileallsn = false;
          this.muchfilesn = false;
          this.buileders = [];
          this.buileder = [];
          this.files = false;
          this.removefiles = false;
          this.dialogVisiblefile = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消改名
    nullfile() {
      this.dialogVisiblefile = false;
      this.numm = -1;
      this.nummfile = -1;
    },
    // 文件上传
    beforeUpload(file) {
      this.user.filename = file.name;
      this.elprogress = true;
      this.uploadFiles = [];
    },
    // 文件上传时的钩子
    handleprogress(file, fileList) {
      this.user.filename = fileList.name;
    },
    // 文件上传成功时的钩子
    handlesuccess(response, file, fileList) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$refs.upload.clearFiles();
        this.uploadFiles = fileList;
        setTimeout(() => {
          this.elprogress = false;
          this.$message({
            showClose: true,
            message: "上传成功",
            type: "success",
          });
        }, 1000);
        this.thisNum = 1;
        documentindex({
          parent_id: window.sessionStorage.getItem("doctourlid"),
          limit: this.limits,
          page: this.thisNum,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            if (res.data.data.self == null) {
              this.totops = false;
            } else {
              this.totops = true;
              this.docmentName = res.data.data.self.name;
              this.selfname = res.data.data.self.name;
              this.user.cate_id = res.data.data.self.id;
            }
            this.page = res.data.data.dir;
            this.pages = res.data.data.file.data;
            this.parent_id = res.data.data.parent.id;
            this.patharr = res.data.data.path;
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });

        this.Apisrc = window.g.ApiUrl + "/document/uploader";
        this.limit = window.g.imgNum;
        if (window.sessionStorage.getItem("doctourlid") == null) {
          window.sessionStorage.setItem("doctourlid") == 0;
          this.user.cate_id = 0;
        }
        if (window.sessionStorage.getItem("doctourlid") == 0) {
          this.docmentName = "根目录";
        }
      }
    },
    removetopfile(index) {
      this.uploadFiles.splice(index, 1);
    },
    // 文件上传失败时的钩子
    handleerror(err, file, fileList) {
      let myError = err.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //滚动条触发事件
    scrollEvent(e) {
      this.numm = -1;
      this.nummfile = -1;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        documentindex({
          parent_id: window.sessionStorage.getItem("doctourlid"),
          limit: this.limits,
          page: ++this.thisNum,
        }).then((res) => {
          if (res.data.data.file.data.length == 0) {
            // this.$message({
            //   showClose: true,
            //   message: "没有更多文件",
            //   type: "success",
            // });
          } else {
            this.page1 = res.data.data.file.data;
            this.page1.forEach((i) => {
              this.pages.push(i);
            });
          }
        });
      }
    },
    // 保存文件夹id
    itemChange(item, index) {
      this.user.cate_id = window.sessionStorage.getItem("doctourlid");
      if (this.buileder.indexOf(index) == -1) {
        this.buileder.push(index);
        window.sessionStorage.setItem("doctourlindex", index);
      } else {
        this.buileder.splice(this.buileder.indexOf(index), 1);
        if (this.buileder.length != 0) {
          this.user.cate_id =
            this.page[this.buileder[this.buileder.length - 1]].parent_id;
          window.sessionStorage.setItem(
            "doctourlindex",
            this.buileder[this.buileder.length - 1]
          );
        }
      }
      // this.buileders = [];
      this.numm = -1;
      this.nummfile = -1;
      this.docfile = true;
      this.files = false;
      // this.filesn = false;
      // this.fileallsn = true;
      // this.muchfilesn = false;
      if (this.buileder.length != 0) {
        documentindex({
          parent_id: this.page[this.buileder[this.buileder.length - 1]].id,
          limit: this.limits,
        }).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.file.total > 20) {
              this.contspan = true;
            } else {
              this.contspan = false;
            }
            this.$loading.hide(); // 隐藏loading
            // if (res.data.data.self == null) {
            //   this.totops = false;
            // } else {
            //   this.totops = true;
            // }
            // this.docmentName = res.data.data.self.name;
            this.filepageName = res.data.data.self.name;
            this.filepage = res.data.data.dir;
            this.filepages = res.data.data.file.data;
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }

      // this.$refs.doccont.style.width = "100%";
      // this.$refs.alltitle.style.width = "100%";
      // this.$refs.doctitle.style.width = "100%";
    },
    // 保存文件id
    itemChanges(item, index) {
      if (this.buileders.indexOf(index) == -1) {
        this.buileders.push(index);
        window.sessionStorage.setItem("filetoindex", index);
        window.sessionStorage.setItem("filetoid", this.pages[index].id);
      } else {
        this.buileders.splice(this.buileders.indexOf(index), 1);
        if (this.buileders.length != 0) {
          window.sessionStorage.setItem(
            "filetoindex",
            this.buileders[this.buileders.length - 1]
          );
          window.sessionStorage.setItem(
            "filetoid",
            this.pages[this.buileders[this.buileders.length - 1]].id
          );
        }
      }
      this.nummfile = -1;
      this.numm = -1;
      this.clicknums = 0;

      if (this.buileders.length != 0) {
        this.voucher =
          this.pages[this.buileders[this.buileders.length - 1]].url;
        this.original_name =
          this.pages[this.buileders[this.buileders.length - 1]].original_name;
        this.create_time =
          this.pages[this.buileders[this.buileders.length - 1]].create_time;
        this.mime = this.pages[this.buileders[this.buileders.length - 1]].mime;
        this.size = this.pages[this.buileders[this.buileders.length - 1]].size;
        if (
          this.pages[this.buileders[this.buileders.length - 1]]
            .identification == null
        ) {
          this.identificationTime = "未认证";
          this.identificationId = "未认证";
          this.identificationOrg = "未认证";
          this.authentication = true;
          this.noauth = false;
        } else {
          this.identificationTime =
            this.pages[
              this.buileders[this.buileders.length - 1]
            ].identification.create_time;
          this.identificationId =
            this.pages[
              this.buileders[this.buileders.length - 1]
            ].identification.cert_id;
          this.identificationOrg =
            this.pages[
              this.buileders[this.buileders.length - 1]
            ].identification.org;
          this.authentication = false;
          this.noauth = true;
        }
      }
      this.files = true;
      this.docfile = false;
    },
    allbuileder() {
      if (
        this.buileder.length != this.page.length ||
        this.buileders.length != this.pages.length
      ) {
        this.buileder = [];
        this.buileders = [];
        for (let index = 0; index < this.page.length; index++) {
          this.buileder.push(index);
        }
        for (let index = 0; index < this.pages.length; index++) {
          this.buileders.push(index);
        }
      } else {
        this.buileder = [];
        this.buileders = [];
      }
    },
    // 下载文件
    downloadExcel() {
      let a = document.createElement("a");
      a.download = name;
      a.href = window.g.Apisrc + this.voucher;
      a.click();
    },
    // 文件预览
    dialogVisibleimag() {
      this.numm = -1;
      this.nummfile = -1;
      this.$refs.doccont.style.width = "100%";
      this.$refs.doctitle.style.width = "100%";
      var url = window.g.Apisrc + this.voucher;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    // 打开文件夹
    opendocments(index) {
      this.numm = -1;
      this.nummfile = -1;
      this.buileder = [];
      this.buileders = [];
      window.sessionStorage.setItem("doctourlid", this.page[index].id);
      this.user.cate_id = this.page[index].id;
      documentindex({
        parent_id: this.page[index].id,
        limit: this.limits,
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.self == null) {
            this.totops = false;
            this.docmentName = "根目录";
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
          }
          this.page = res.data.data.dir;
          this.refresh();
          this.pages = res.data.data.file.data;
          this.parent_id = res.data.data.self.id;
          this.selfname = res.data.data.self.name;
          this.docfile = false;
          this.files = false;
          this.removefiles = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件夹改名
    openright(index) {
      this.numm = -1;
      this.dialogVisiblefilebox = true;
      this.filebox = this.page[index].name;
    },
    // 路径跳转文件夹
    todoc(index) {
      window.sessionStorage.setItem("doctourlid", this.patharr[index].id);
      this.user.cate_id = this.patharr[index].id;
      documentindex({ parent_id: this.patharr[index].id, limit: 20 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.numm = -1;
            this.nummfile = -1;
            this.filesn = false;
            this.fileallsn = false;
            this.muchfilesn = false;
            this.buileders = [];
            this.buileder = [];
            this.docfile = false;
            this.files = false;
            this.removefiles = false;
            if (res.data.data.self == null) {
              this.totops = false;
              this.docmentName = "根目录";
            } else {
              this.totops = true;
              this.docmentName = res.data.data.self.name;
            }
            this.page = res.data.data.dir;
            this.refresh();
            this.pages = res.data.data.file.data;
            this.parent_id = res.data.data.self.id;
            this.selfname = res.data.data.self.name;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 路径跳转根目录
    toheaddoc() {
      window.sessionStorage.setItem("doctourlid", 0);
      this.user.cate_id = 0;
      documentindex({ parent_id: 0, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          this.numm = -1;
          this.nummfile = -1;
          this.numm = -1;
          this.nummfile = -1;
          this.filesn = false;
          this.fileallsn = false;
          this.muchfilesn = false;
          this.buileders = [];
          this.buileder = [];
          this.docfile = false;
          this.files = false;
          this.removefiles = false;
          if (res.data.data.self == null) {
            this.totops = false;
            this.docmentName = "根目录";
            this.parent_id = "";
            this.selfname = "";
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
            this.parent_id = res.data.data.self.id;
            this.selfname = res.data.data.self.name;
          }
          this.patharr = res.data.data.path;
          this.page = res.data.data.dir;
          this.pages = res.data.data.file.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      documentindex({
        parent_id: window.sessionStorage.getItem("doctourlid"),
        keywords: this.input,
        limit: this.limits,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          if (res.data.data.self == null) {
            this.totops = false;
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
            this.selfname = res.data.data.self.name;
            this.user.cate_id = res.data.data.self.id;
          }
          this.page = res.data.data.dir;
          this.pages = res.data.data.file.data;
          // this.parent_id = res.data.data.parent.id;
          // this.patharr = res.data.data.path;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索清空
    resetForm() {
      this.input = "";
      documentindex({
        parent_id: 0,
        limit: this.limits,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          if (res.data.data.self == null) {
            this.totops = false;
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
            this.selfname = res.data.data.self.name;
            this.user.cate_id = res.data.data.self.id;
          }
          this.page = res.data.data.dir;
          this.pages = res.data.data.file.data;
          this.parent_id = res.data.data.parent.id;
          this.patharr = res.data.data.path;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      this.operationtf = false;
      this.numm = -1;
      this.nummfile = -1;
      this.Apisrc = window.g.ApiUrl + "/document/uploader";
      this.limit = window.g.imgNum;
      if (window.sessionStorage.getItem("doctourlid") == null) {
        window.sessionStorage.setItem("doctourlid") == 0;
        this.user.cate_id = 0;
      }
      if (window.sessionStorage.getItem("doctourlid") == 0) {
        this.docmentName = "根目录";
      }
      documentindex({
        parent_id: window.sessionStorage.getItem("doctourlid"),
        limit: this.limits,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          if (res.data.data.self == null) {
            this.totops = false;
            this.selfname = "";
          } else {
            this.totops = true;
            this.docmentName = res.data.data.self.name;
            this.selfname = res.data.data.self.name;
            this.user.cate_id = res.data.data.self.id;
          }
          if (res.data.data.parent == null || "") {
            this.parent_id = 0;
          } else {
            this.parent_id = res.data.data.parent.id;
          }
          this.page = res.data.data.dir;
          this.pages = res.data.data.file.data;
          if (res.data.data.path == null || "") {
            this.patharr = "";
          } else {
            this.patharr = res.data.data.path;
          }
          // this.fileboxshownull = false;
          // this.fileshownull = false;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件夹移动
    Filemovement(index) {
      this.movepageid = this.page[index].id;
      this.dialogVisiblemove = true;
      this.numm = -1;
      this.nummfile = -1;
      documentindex({ parent_id: 0, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          this.allfilepage = res.data.data.dir;
          this.allfilepages = res.data.data.file.data;
          this.filepageparent_id = res.data.data.parent.id;
          this.allfilepatharr = res.data.data.path;
          if (res.data.data.self == null) {
            this.allfiletotops = false;
          } else {
            this.allfiletotops = true;
          }
          if (res.data.data.path.length == 0) {
            this.allfilecontid = 0;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件移动
    Filemovements(index) {
      this.movepagesid = this.pages[index].id;
      this.dialogVisiblemove = true;
      this.numm = -1;
      this.nummfile = -1;
      documentindex({ parent_id: 0, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          this.allfilepage = res.data.data.dir;
          this.allfilepages = res.data.data.file.data;
          this.filepageparent_id = res.data.data.parent.id;
          this.allfilepatharr = res.data.data.path;
          if (res.data.data.self == null) {
            this.allfiletotops = false;
          } else {
            this.allfiletotops = true;
          }
          if (res.data.data.path.length == 0) {
            this.allfilecontid = 0;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件文件夹一起移动
    Filemovementall() {
      // this.movepageid = this.page[index].id;
      this.dialogVisiblemove = true;
      this.numm = -1;
      this.nummfile = -1;
      documentindex({ parent_id: 0, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          this.allfilepage = res.data.data.dir;
          this.allfilepages = res.data.data.file.data;
          this.filepageparent_id = res.data.data.parent.id;
          this.allfilepatharr = res.data.data.path;
          if (res.data.data.self == null) {
            this.allfiletotops = false;
          } else {
            this.allfiletotops = true;
          }
          if (res.data.data.path.length == 0) {
            this.allfilecontid = 0;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件移动中的打开文件
    opendilogflie(index) {
      this.allfilecontid = this.allfilepage[index].id;
      documentindex({ parent_id: this.allfilepage[index].id, limit: 50 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.allfilepage = res.data.data.dir;
            this.allfilepages = res.data.data.file.data;
            this.filepageparent_id = res.data.data.parent.id;
            this.allfilepatharr = res.data.data.path;
            if (res.data.data.self == null) {
              this.allfiletotops = false;
            } else {
              this.allfiletotops = true;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 文件移动中的返回上一级
    allfiletop() {
      this.allfilecontid = this.filepageparent_id;
      documentindex({ parent_id: this.filepageparent_id, limit: 50 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.allfilepage = res.data.data.dir;
            this.allfilepages = res.data.data.file.data;
            this.filepageparent_id = res.data.data.parent.id;
            this.allfilepatharr = res.data.data.path;
            if (res.data.data.self == null) {
              this.allfiletotops = false;
            } else {
              this.allfiletotops = true;
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 文件移动中的跳转根目录
    toallfiledoc() {
      documentindex({ parent_id: 0, limit: 20 }).then((res) => {
        if (res.data.code == 200) {
          this.allfilecontid = 0;
          this.allfilepage = res.data.data.dir;
          this.allfilepages = res.data.data.file.data;
          this.filepageparent_id = res.data.data.parent.id;
          this.allfilepatharr = res.data.data.path;
          if (res.data.data.self == null) {
            this.allfiletotops = false;
          } else {
            this.allfiletotops = true;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 文件移动中的点击路径跳转
    allfileitem(index) {
      documentindex({
        parent_id: this.allfilepatharr[index].id,
        limit: 50,
      }).then((res) => {
        if (res.data.code == 200) {
          this.allfilecontid = this.allfilepatharr[index].id;
          this.allfilepage = res.data.data.dir;
          this.allfilepages = res.data.data.file.data;
          this.filepageparent_id = res.data.data.parent.id;
          this.allfilepatharr = res.data.data.path;
          if (res.data.data.self == null) {
            this.allfiletotops = false;
          } else {
            this.allfiletotops = true;
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 移动确定
    movefilesuer() {
      let builederid = [];
      let builedersid = [];
      if (this.buileder.length == 0 && this.buileders.length == 0) {
        builederid.push(this.movepageid);
        builedersid.push(this.movepagesid);
      } else {
        this.buileder.forEach((i) => {
          builederid.push(this.page[i].id);
        });
        this.buileders.forEach((i) => {
          builedersid.push(this.pages[i].id);
        });
      }
      documentmove({
        target: this.allfilecontid,
        dirs: builederid,
        files: builedersid,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.buileder = [];
          this.buileders = [];
          this.dialogVisiblemove = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    filemouseenter(index) {
      this.filemouse = index;
    },
    filemouseleave(index) {
      this.filemouse = -1;
    },
    filemouseenters(index) {
      this.filesmouse = index;
    },
    filemouseleaves(index) {
      this.filesmouse = -1;
      this.operationtf = false;
    },
    // 关闭黑色悬浮框
    outblackbox() {
      this.buileder = [];
      this.buileders = [];
    },
  },
  created() {
    if (document.body.clientHeight < 900) {
      this.screenHeight = document.body.clientHeight - 260;
      this.limits = 20;
    } else if (900 < document.body.clientHeight < 1000) {
      this.screenHeight = document.body.clientHeight - 300;
      this.limits = 20;
    } else if (1000 < document.body.clientHeight < 1060) {
      this.screenHeight = document.body.clientHeight - 350;
      this.limits = 20;
    } else {
      this.screenHeight = document.body.clientHeight - 400;
      this.limits = 30;
    }
    this.Apisrc = window.g.ApiUrl + "/document/uploader";
    this.limit = window.g.imgNum;
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    if (window.sessionStorage.getItem("doctourlid") == null) {
      window.sessionStorage.setItem("doctourlid", 0);
      this.user.cate_id = 0;
    }
    if (window.sessionStorage.getItem("doctourlid") == 0) {
      this.docmentName = "根目录";
    }
    documentindex({
      parent_id: window.sessionStorage.getItem("doctourlid"),
      limit: this.limits,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        if (res.data.data.self == null) {
          this.totops = false;
        } else {
          this.totops = true;
          this.docmentName = res.data.data.self.name;
          this.selfname = res.data.data.self.name;
          this.user.cate_id = res.data.data.self.id;
        }
        this.page = res.data.data.dir;
        this.pages = res.data.data.file.data;
        this.parent_id = res.data.data.parent.id;
        this.patharr = res.data.data.path;
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>

<style scoped>
.fileTemp {
  text-align: left;
  padding: 3px 10px;
  margin: 5px 0;
  background-color: rgb(245, 241, 241);
}
.progress-bar {
  width: 100%;
  height: 10px;
  background-color: #f0f0f0;
}
.progress {
  height: 100%;
  background-color: #4caf50;
  width: 1;
}
.progress.animate {
  animation: progress 1s ease-out forwards;
}
@keyframes progress {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.functionbox {
  /* min-width: 184px; */
  height: 50px;
  padding: 0 10px;
  background: rgba(15, 15, 15, 0.8);
  border-radius: 8px;
  position: fixed;
  bottom: 60px;
  left: 46%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}
.functionitem {
  width: 28px;
  height: 28px;
  margin: 0 5px;
}
.functionboximg {
  position: relative;
  top: 5px;
  left: 6px;
  filter: drop-shadow(0 0 white);
}
.muchoperation {
  width: 100px;
  height: 160px;
  z-index: 200;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #e9ebf2;
  border-radius: 6px;
  position: absolute;
  top: 35px;
  left: 40px;
}
.operationitem {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.operationitem:hover {
  width: 100px;
  height: 40px;
  background: #f4fbfc;
  border-radius: 6px;
  color: #52c5cb;
}
.nameover {
  /* display: inline-block; */
  width: 300px;
  /*第一步： 溢出隐藏 */
  overflow: hidden;
  /* 第二步：让文本不会换行， 在同一行继续 */
  white-space: nowrap;
  /* 第三步：用省略号来代表未显示完的文本 */
  text-overflow: ellipsis;
}
.detailover {
  /* display: inline-block; */
  min-width: 150px;
  /*第一步： 溢出隐藏 */
  overflow: hidden;
  /* 第二步：让文本不会换行， 在同一行继续 */
  white-space: nowrap;
  /* 第三步：用省略号来代表未显示完的文本 */
  text-overflow: ellipsis;
}
.jiantouyou {
  position: relative;
  top: 2px;
}
.nullfilebox {
  width: 100px;
  padding: 25px 0 15px 0;
  line-height: 25px;
  background: #f7f9fc;
  margin: 0 8px 0 8px;
  font-size: 12px;
}
.icon-fanhuishangji1 {
  background-image: -webkit-linear-gradient(left bottom, #0aa77a, #90fdbc);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.icon-shangchuanwenjian {
  background-image: -webkit-linear-gradient(left bottom, #e0b421, #f6fd90);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.icon-shangchuanyunpan {
  background-image: -webkit-linear-gradient(left bottom, #3678da, #a9eafa);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.Retrieveform {
  background: #fff;
  overflow-y: auto;
  overflow-x: hidden;
}
/* .Retrieveform::-webkit-scrollbar {
  width: 0 !important;
} */
.buileder {
  width: 16px;
  height: 16px;
  line-height: 14px;
  text-align: center;
  color: #fff;
  border: 1px solid #efefef;
  border-radius: 3px;
  margin-left: 10px;
}

.borderB {
  border-bottom: 1px solid #f7f4f4;
  width: 100%;
  margin: auto;
}
.borderB:hover {
  background: #f7fcfc;
}
.dialogmove {
  margin: 20px 0 20px 0;
  height: 450px;
  overflow-y: scroll;
}
/* .dialogmove::-webkit-scrollbar {
  width: 0 !important;
} */
.backhover {
  background: #f2faff;
}

.namehover:hover {
  color: #52c5cb;
}
.doctitle {
  color: #7c7c7c;
  font-size: 14px;
  font-weight: 600;
}
.doc {
  color: #ffb452;
}
.docgreen {
  color: #1b9000;
}
.icon-folder-full {
  font-size: 18px;
}
.icon-PNG {
  font-size: 18px;
}
.docdetails {
  /* height: 600px; */
  background: #fff;
  color: #7c7c7c;
  border-left: 1px solid rgb(240, 237, 237);
}
.headfile {
  background-color: #f8f8f9;
  font-size: 14px;
  color: #6a7589;
}
.docicon {
  font-family: "iconfont" !important;
  font-size: 100px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cecdcd;
}
.titlecor {
  color: #969eac;
  border-top: 1px solid #f0f0f0;
  overflow: hidden;
  word-break: break-all;
}
.titlestyle {
  margin-top: -40px;
  font-size: 14px;
  color: #454d5a;
  font-weight: 600;
  word-break: break-all;
}
.titlestyles {
  font-size: 14px;
  color: #454d5a;
  font-weight: 600;
  word-break: break-all;
}

.download {
  background: #0039bf;
  color: #fff;
  height: 25px;
  line-height: 25px;
  width: 60px;
  border-radius: 5px;
  cursor: pointer;
}
.download:hover {
  background: #355fc0;
}
.preview {
  background: #098c01;
  color: #fff;
  height: 25px;
  line-height: 25px;
  width: 60px;
  border-radius: 5px;
  cursor: pointer;
}
.preview:hover {
  background: #49a844;
}
.elradio >>> .el-radio {
  height: 35px;
}
.elradio >>> .el-radio:hover {
  background: #fafafc;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.inputshare {
  width: 100%;
}
.eldialogheader >>> .el-dialog__header {
  padding: 0;
}
.elradiogroup {
  position: relative;
}

.rightdialog {
  position: absolute;
  left: 35%;
}

.rightdialogborder {
  border-bottom: 1px solid #efefef;
}
.active {
  background: #52c5cb;
}
.actives {
  background: #52c5cb;
}
.filedetail {
  overflow-y: scroll;
}
.filedetail::-webkit-scrollbar {
  width: 0 !important;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}

.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 90%;
  margin: auto;
}
.btnn {
  width: 100%;
  height: 25%;
  margin: auto;
  border: none;
  background: white;
}
.movebtnn {
  width: 100%;
  text-align: left;
}
.drawer {
  width: 98%;
  margin: auto;
  text-align: center;
}
.btnns {
  color: red;
}
.bh {
  font-size: 12px;
}
.nullbtn {
  background: red;
  color: white;
}
.addinput {
  width: 70%;
  margin: 50px auto 40px;
}
</style>